import { render, staticRenderFns } from "./SearchUploadImage.vue?vue&type=template&id=12a78606"
import script from "./SearchUploadImage.vue?vue&type=script&lang=js"
export * from "./SearchUploadImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports